import React from 'react';
import FormSetting from '../../layout/FormSetting';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';

const GiftEmail = ({ ...props }) => {

    return (
        <FormSetting
            label='Gift Email'
            getInputs={QuestRoute.settings.giftEmails}
            onSubmit={e => HamQuest.put(QuestRoute.settings.giftEmails, { ...e })}
            editable
        >
            <Input
                label='Wash Name'
                name='giftEmailHeader'
            />
            <Preput
                label='Footer'
                name='giftEmailFooter'
            />
            <Input
                label='Apple App Store Link'
                name='appleAppStoreLink'
            />
            <Input
                label='Google Play Link'
                name='googlePlayStoreLink'
            />
        </FormSetting>
    );
}

export default GiftEmail;